import {
    parsePhoneNumberFromString,
    parseIncompletePhoneNumber,
    getExampleNumber,
    isSupportedCountry,
} from 'libphonenumber-js/min';
import { GeoService } from './geo';

import examples from 'libphonenumber-js/examples.mobile.json';

export class PhoneService {
    constructor() {
        this.countryCode = GeoService.countryCode;

        if (isSupportedCountry(this.countryCode) === false) {
            this.countryCode = 'US';
        }
    }

    format(text) {
        let formattedPhone = parsePhoneNumberFromString(text, this.countryCode);

        if (!formattedPhone) {
            return parseIncompletePhoneNumber(text);
        }

        return formattedPhone.formatInternational();
    }

    getExample() {
        return getExampleNumber(this.countryCode, examples).formatInternational();
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/services/phone.js